<template>
<span
    class="label"
    v-bind:class="{
        'label-pf': person_type === 1,
        'label-pfext': person_type === 2,
        'label-pm': person_type === 0,
        'label-pmext': person_type === 3,
        'label-finance-society': person_type === 4,
      }">
    <template v-if="person_type === 0">PM Mex</template>
    <template v-if="person_type === 1">PF Mex</template>
    <template v-if="person_type === 2">PF Ext</template>
    <template v-if="person_type === 3">PM Ext</template>
    <template v-if="person_type === 4">Entidad Financiera</template>
</span>
</template>

<script>
export default {
    name: "person-type-label",
    props: ["person_type"]
}
</script>

<style scoped>
.label-pfext {
    background: #ffa726;
    color: #000;
}
.label-pmext {
    background: #ff8a65;
    color: #000;
}
.label-finance-society {
    background: #00766c;
    color: #FFF;
}
</style>
